import React from 'react';
import { TextField, AutoCompleteField } from '../../components/widgets';
import css from './Edit.pcss';
import DropdownField from '../../components/molecules/DropdownField';

const FIELD_TYPES = {
    text: TextField,
    tags: AutoCompleteField,
    dropdown: DropdownField,
};

const EditPanel = ({ title, fields, edit, invalid, metadata, onChange, disabled }) => {
    const getFieldOptions = field => {
        const options = metadata ? metadata[field.options] : [];
        let editValue = edit[field.value];
        if (field.type === 'tags') {
            const editValues = editValue.map(val => val.value);
            editValue = options.filter(option => editValues.includes(option.value));
        }

        return {
            label: field.label,
            value: editValue,
            selected: editValue,
            onChange: value => {
                onChange(field.onChange, value);
            },
            error: field.error,
            placeholder: disabled ? '-' : field.placeholder,
            options,
            debounce: 300,
            items: field.items,
            labelTooltip: field.labelTooltip,
            disabled,
        };
    };

    return (
        <div className={css.panel}>
            <div className={css.header}>{title}</div>
            <div className={css.body}>
                {fields.map(field => {
                    const Field = FIELD_TYPES[field.type];

                    return (
                        <div key={`field_${field.value}`} className={css.detailsFieldHolder}>
                            <Field {...getFieldOptions(field)} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default EditPanel;
